import React from 'react';

const MakeAdmin = () => {
    return (
        <div>
            <h2>make add min</h2>
        </div>
    );
};

export default MakeAdmin;